var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signSuccess"},[_c('img',{staticClass:"posterBg",attrs:{"src":_vm.signSuccessBg}}),_c('main',[_c('section',[_c('dl',[_c('dt',{staticClass:"team-name"},[_vm._v(" "+_vm._s(_vm.teamInfo.teamName || "")+" ")]),_c('dd',{staticClass:"service-point-name"},[_vm._v(_vm._s(_vm.teamInfo.servicePointName || ""))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }